import { RefreshCw, X } from 'lucide-react';
import type { ReactElement } from 'react';

interface AppVersionBannerProps {
  onRefresh: () => void;
  onDismiss: () => void;
}

export function AppVersionBanner({ onRefresh, onDismiss }: AppVersionBannerProps): ReactElement {
  return (
    <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 w-[calc(100%-2rem)] max-w-md">
      <div className="flex items-center gap-3 px-4 py-3 bg-theme-primary-fill text-theme-on-primary-fill rounded-xl shadow-lg shadow-theme-primary/20">
        <RefreshCw className="w-4 h-4 shrink-0" />
        <span className="text-sm font-medium flex-1">
          We&apos;ve made improvements! Refresh to get the latest.
        </span>
        <button
          type="button"
          onClick={onRefresh}
          className="px-3 py-1 text-xs font-semibold bg-white/20 hover:bg-white/30 rounded-lg transition-colors"
        >
          Refresh
        </button>
        <button
          type="button"
          onClick={onDismiss}
          className="p-1 hover:bg-white/20 rounded-lg transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
}
